@if (!hideText()) {
  <footer class="footer">
    <div class="container">
      <div class="container inner">
        <div class="providers-container">
          <div class="footer__title">{{ 't.payments-methods' | translate }}</div>
          <ng-container *appShellNoSSR>
            <ng-container *ngTemplateOutlet="paymentMethodsNoSSR"></ng-container>
          </ng-container>
          <ng-container *appShellRenderSSR>
            <ng-container *ngTemplateOutlet="paymentMethodsSSR"></ng-container>
          </ng-container>
        </div>
        <ng-container *appShellNoSSR>
          <ng-container *ngTemplateOutlet="socialNoSSR"></ng-container>
        </ng-container>
        <ng-container *appShellRenderSSR>
          <ng-container *ngTemplateOutlet="socialSSR"></ng-container>
        </ng-container>
        <div class="providers center align-center">
          <ng-container *appShellNoSSR>
            <ng-container *ngTemplateOutlet="licenseNoSSR"></ng-container>
          </ng-container>
          <ng-container *appShellRenderSSR>
            <ng-container *ngTemplateOutlet="licenseSSR"></ng-container>
          </ng-container>
          </div>
          <ng-content></ng-content>
        </div>
      </div>
    </footer>
  }


<ng-template #licenseNoSSR>
  @defer (on viewport) {
    @if (license$ | async; as license) {
      @if (license.Url) {
        <a class="providers__item --curacao" target="_blank" rel="nonoopener" [href]="license?.Url">
          <img ClassLoaded [src]="license?.Img" alt="SpinSamurai casino - license">
        </a>
      } @else {
        <div class="providers__item --curacao">
          <img ClassLoaded [src]="license?.Img" alt="SpinSamurai casino - license">
        </div>
      }
    }
    <img ClassLoaded class="providers__item" [attr.data-src]="'/assets/svg/security-logos/be-gamble-aware.svg'" alt="be-gamble-aware">
    <img ClassLoaded class="providers__item" [attr.data-src]="'/assets/svg/security-logos/comodossl.svg'" alt="comodossl">
    <img ClassLoaded class="providers__item ask" src="/assets/svg/askgamblers.svg" alt="askgamblers">
  } @placeholder {
    <div class="preloader"></div>
  }
</ng-template>

<ng-template #licenseSSR>
  @if (license$ | async; as license) {
    @if (license.Url) {
      <a class="providers__item --curacao" target="_blank" rel="nonoopener" [href]="license?.Url">
        <img ClassLoaded [src]="license?.Img" alt="SpinSamurai casino - license">
      </a>
    } @else {
      <div class="providers__item --curacao">
        <img ClassLoaded [src]="license?.Img" alt="SpinSamurai casino - license">
      </div>
    }
  }
  <img ClassLoaded class="providers__item" [attr.data-src]="'/assets/svg/security-logos/be-gamble-aware.svg'" alt="be-gamble-aware">
  <img ClassLoaded class="providers__item" [attr.data-src]="'/assets/svg/security-logos/comodossl.svg'" alt="comodossl">
  <img ClassLoaded class="providers__item ask" src="/assets/svg/askgamblers.svg" alt="askgamblers">
</ng-template>
<ng-template #socialNoSSR>
  @defer (on viewport) {
    @if (social$ | async; as social) {
      <div class="social__actions">
        @if (social[0]?.DiscordBtnLink; as url) {
          <a [href]="url">
            <img ClassLoaded [attr.data-src]="'/assets/img/social-redesign/discord.png'" alt="discord" class="discord">
          </a>
        }
        @if (social[0]?.TelegramBtnLink; as url) {
          <a [href]="url">
            <img ClassLoaded [attr.data-src]="'/assets/img/social-redesign/telegram.png'" alt="telegram" class="telegram">
          </a>
        }
        @if (social[0]?.TwitterBtnLink; as url) {
          <a [href]="url">
            <img ClassLoaded [attr.data-src]="'/assets/img/social-redesign/twitter.png'" alt="twitter" class="twitter">
          </a>
        }
        @if (social[0]?.InstagramBtnLink; as url) {
          <a [href]="url">
            <img ClassLoaded [attr.data-src]="'/assets/img/social-redesign/instagram.png'" alt="instagram" class="instagram">
          </a>
        }
      </div>
    }
    @if (copyright$ | async; as copyright) {
      <div class="copyright"
           [innerHTML]="copyright[0]?.Content | safe: 'html'"></div>
    }
  } @placeholder {
    <div class="preloader"></div>
  }
</ng-template>

<ng-template #socialSSR>
  @if (social$ | async; as social) {
    <div class="social__actions">
      @if (social[0]?.DiscordBtnLink; as url) {
        <a [href]="url">
          <img ClassLoaded [attr.data-src]="'/assets/img/social-redesign/discord.png'" alt="discord" class="discord">
        </a>
      }
      @if (social[0]?.TelegramBtnLink; as url) {
        <a [href]="url">
          <img ClassLoaded [attr.data-src]="'/assets/img/social-redesign/telegram.png'" alt="telegram" class="telegram">
        </a>
      }
      @if (social[0]?.TwitterBtnLink; as url) {
        <a [href]="url">
          <img ClassLoaded [attr.data-src]="'/assets/img/social-redesign/twitter.png'" alt="twitter" class="twitter">
        </a>
      }
      @if (social[0]?.InstagramBtnLink; as url) {
        <a [href]="url">
          <img ClassLoaded [attr.data-src]="'/assets/img/social-redesign/instagram.png'" alt="instagram" class="instagram">
        </a>
      }
    </div>
  }
  @if (copyright$ | async; as copyright) {
    <div class="copyright"
         [innerHTML]="copyright[0]?.Content | safe: 'html'"></div>
  }
</ng-template>
<ng-template #paymentMethodsNoSSR>
  @defer (on viewport) {
    <app-accordion-button [isFooter]="true">
      @if (banking.paymentList$ | async; as paymentList) {
        <div class="providers center clickable">
          <div class="payments">
            @for (payment of paymentList; track $index) {
              @if (!payment?.IsCrypto) {
                <img
                  ClassLoaded
                  class="providers__item {{payment?.slug}}"
                  DeleteNotFound
                  routerLink="/profile/deposit"
                  (click)="onProviderClick(payment)"
                  [attr.data-src]="payment?.footerImg"
                  ImgDimension height="25" width="60"
                  [alt]="payment?.slug"
                >
              }
            }
          </div>
        </div>
        <div class="providers center clickable">
          <div class="payments">
            @for (payment of paymentList; track $index) {
              @if (payment?.IsCrypto) {
                <img
                  ClassLoaded
                  DeleteNotFound
                  class="providers__item"
                  routerLink="/profile/deposit"
                  (click)="onProviderClick(payment)"
                  [attr.data-src]="payment?.footerImg"
                  [alt]="payment?.slug"
                  ImgDimension height="25" width="60"
                >
              }
            }
          </div>
        </div>
      }
    </app-accordion-button>
    <div class="footer__title">{{ 't.providers' | translate }}</div>
    <app-accordion-button [isFooter]="true">
      @if (providerList$ | async; as providerList) {
        <div class="providers center clickable">
          @for (provider of providerList; track $index) {
            <a class="providers__item"
               (click)="onProviderClick(provider)"
               [href]="'/games/' + provider.alias"
               DeleteNotFound
            >
              @if (!provider?.customImg) {
                <img
                  ClassLoaded
                  [ngClass] = "{'provider-light':provider?.alias === 'gameburgerstudios' || provider?.alias ===
                        'reflexgaming' || provider?.alias === 'goldcoinstudios'}"
                  ImgDimension height="25" width="60"
                  [attr.data-src] = "provider.imgAlias" [alt]="provider?.alias"
                >
              }
              @if (provider?.customImg) {
                <img
                  ClassLoaded
                  class="{{provider.alias}}"
                  [attr.data-src] = "provider?.customImg"
                  [alt]="provider?.alias"
                >
              }
            </a>
          }
        </div>
      }
    </app-accordion-button>
    @if (partnerList$ | async; as partnerList) {
      <div class="providers center clickable">
        @for (partner of partnerList; track partner) {
          @if (partner?.Logo) {
            <a target="_blank" class="providers__item" [href]="partner?.Link">
              <img ClassLoaded [attr.data-src]="partner?.Logo" [alt]="partner?.Text" ImgDimension height="25" width="60">
            </a>
          }
        }
      </div>
    }
  } @placeholder {
    <app-skeleton [count]="1" [type]="'block'"></app-skeleton>
  }
</ng-template>

<ng-template #paymentMethodsSSR>
    <app-accordion-button [isFooter]="true">
      @if (banking.paymentList$ | async; as paymentList) {
        <div class="providers center clickable">
          <div class="payments">
            @for (payment of paymentList; track $index) {
              @if (!payment?.IsCrypto) {
                <img
                  ClassLoaded
                  class="providers__item {{payment?.slug}}"
                  DeleteNotFound
                  routerLink="/profile/deposit"
                  (click)="onProviderClick(payment)"
                  [attr.data-src]="payment?.footerImg"
                  ImgDimension height="25" width="60"
                  [alt]="payment?.slug"
                >
              }
            }
          </div>
        </div>
        <div class="providers center clickable">
          <div class="payments">
            @for (payment of paymentList; track $index) {
              @if (payment?.IsCrypto) {
                <img
                  ClassLoaded
                  DeleteNotFound
                  class="providers__item"
                  routerLink="/profile/deposit"
                  (click)="onProviderClick(payment)"
                  [attr.data-src]="payment?.footerImg"
                  [alt]="payment?.slug"
                  ImgDimension height="25" width="60"
                >
              }
            }
          </div>
        </div>
      }
    </app-accordion-button>
    <div class="footer__title">{{ 't.providers' | translate }}</div>
    <app-accordion-button [isFooter]="true">
      @if (providerList$ | async; as providerList) {
        <div class="providers center clickable">
          @for (provider of providerList; track $index) {
            <a class="providers__item"
               (click)="onProviderClick(provider)"
               [href]="'/games/' + provider.alias"
               DeleteNotFound
            >
              @if (!provider?.customImg) {
                <img
                  ClassLoaded
                  [ngClass] = "{'provider-light':provider?.alias === 'gameburgerstudios' || provider?.alias ===
                        'reflexgaming' || provider?.alias === 'goldcoinstudios'}"
                  ImgDimension height="25" width="60"
                  [attr.data-src] = "provider.imgAlias" [alt]="provider?.alias"
                >
              }
              @if (provider?.customImg) {
                <img
                  ClassLoaded
                  class="{{provider.alias}}"
                  [attr.data-src] = "provider?.customImg"
                  [alt]="provider?.alias"
                >
              }
            </a>
          }
        </div>
      }
    </app-accordion-button>
    @if (partnerList$ | async; as partnerList) {
      <div class="providers center clickable">
        @for (partner of partnerList; track partner) {
          @if (partner?.Logo) {
            <a target="_blank" class="providers__item" [href]="partner?.Link">
              <img ClassLoaded [attr.data-src]="partner?.Logo" [alt]="partner?.Text" ImgDimension height="25" width="60">
            </a>
          }
        }
      </div>
    }
</ng-template>
